module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04_copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("Copyright © 2007 by the University of Texas Press"), _c('br'), _vm._v("All rights reserved"), _c('br'), _vm._v("Printed in the United States of America"), _c('br'), _vm._v("First edition, 2007")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The Louann Atkins Temple Women & Culture Series is supported by Allison, Doug, Taylor, and Andy Bacon; Margaret, Lawrence, Will, John, and Annie Temple; Larry Temple; the Temple-Inland Foundation; and the National Endowment for the Humanities.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Requests for permission to reproduce material from this work should be sent to:")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Permissions"), _c('br'), _vm._v("University of Texas Press"), _c('br'), _vm._v("P.O. Box 7819"), _c('br'), _vm._v("Austin, TX 78713-7819"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.utexas.edu/utpress/about/bpermission.html",
      "target": "_blank"
    }
  }, [_vm._v("www.utexas.edu/utpress/about/bpermission.html")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f00iv-01.jpg"
    }
  }), _vm._v(" The paper used in this book meets the minimum requirements of "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANSI/NISO")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("Z")]), _vm._v("39.48-1992 ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v("1997) (Permanence of Paper).")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Jordan, Barbara, 1936–1996.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Barbara Jordan / Speaking the truth with eloquent thunder ; edited by Max Sherman.—1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("p. cm.—(Louann Atkins Temple women & culture series; bk. 15) ISBN-13: 978-0-292-71637-7 (cloth: alk. paper) "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISBN-10:")]), _vm._v("0-292-71637-0 (cloth: alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("1. United States—Politics and government—1974-1977. 2. United States—Politics and government—1977-1981. 3. United States—Politics and government—1981-1989. 4. United States—Politics and government—1989–5. Civil rights—United States. 6. Political ethics—United States. 7. Democracy—United States. 8. Jordan, Barbara, 1936–1996. 9. Speeches, addresses, etc., American. I. Sherman, Max R. II. Title. III. Series.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("E838.5.J6735   2007"), _c('br'), _vm._v("328.73092—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("[B]                                                                  2006017267")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99c55960","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copy.vue
// module id = 69
// module chunks = 0